import { lazy, Suspense } from "react";
import type { DashboardCharts } from "@/lib/analytics";

function ChartBlockSkeleton() {
  return (
    <div className="p-4 sm:p-5">
      <div className="h-3 w-28 skeleton-shimmer rounded-full" />
      <div className="mt-2 h-3 w-44 skeleton-shimmer rounded-full" />
      <div className="mt-4 h-[200px] skeleton-shimmer rounded-3xl" />
    </div>
  );
}

const CarsByMakeChart = lazy(() =>
  import("./DashboardCharts").then((mod) => ({ default: mod.CarsByMakeChart }))
);

const FuelCharts = lazy(() =>
  import("./DashboardCharts").then((mod) => ({ default: mod.FuelCharts }))
);

export function LazyCarsByMakeChart({ charts }: { charts: DashboardCharts }) {
  return (
    <Suspense fallback={<ChartBlockSkeleton />}>
      <CarsByMakeChart charts={charts} />
    </Suspense>
  );
}

export function LazyFuelCharts({ charts }: { charts: DashboardCharts }) {
  return (
    <Suspense fallback={<ChartBlockSkeleton />}>
      <FuelCharts charts={charts} />
    </Suspense>
  );
}
